import { createAction, props } from '@ngrx/store';
import { MasterContactAddress } from './models/MasterContactAddress';

// Load MasterContactAddresses
export const loadMasterContactAddresses = createAction(
    '[MasterContactAddresses] Load MasterContactAddresses',
    props<{ addresses: MasterContactAddress[] }>()
);

export const loadMasterContactAddressesSuccess = createAction(
    '[MasterContactAddresses] Load MasterContactAddresses Success',
    props<{ addresses: MasterContactAddress[] }>()
);

export const loadMasterContactAddressesFailure = createAction(
    '[MasterContactAddresses] Load MasterContactAddresses Failure',
    props<{ error: string }>()
);

// Add MasterContactAddress
export const addMasterContactAddress = createAction(
    '[MasterContactAddresses] Add MasterContactAddress',
    props<{ address: MasterContactAddress }>()
);

export const addMasterContactAddressSuccess = createAction(
    '[MasterContactAddresses] Add MasterContactAddress Success',
    props<{ address: MasterContactAddress }>()
);

export const addMasterContactAddressFailure = createAction(
    '[MasterContactAddresses] Add MasterContactAddress Failure',
    props<{ error: string }>()
);

// Update MasterContactAddress
export const updateMasterContactAddress = createAction(
    '[MasterContactAddresses] Update MasterContactAddress',
    props<{ address: MasterContactAddress }>()
);

export const updateMasterContactAddressSuccess = createAction(
    '[MasterContactAddresses] Update MasterContactAddress Success',
    props<{ address: MasterContactAddress }>()
);

export const updateMasterContactAddressFailure = createAction(
    '[MasterContactAddresses] Update MasterContactAddress Failure',
    props<{ error: string }>()
);

// Delete MasterContactAddress
export const deleteMasterContactAddress = createAction(
    '[MasterContactAddresses] Delete MasterContactAddress',
    props<{ addressId: string }>()
);

export const deleteMasterContactAddressSuccess = createAction(
    '[MasterContactAddresses] Delete MasterContactAddress Success',
    props<{ addressId: string }>()
);

export const deleteMasterContactAddressFailure = createAction(
    '[MasterContactAddresses] Delete MasterContactAddress Failure',
    props<{ error: string }>()
);